var _defs, _circle, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgApartment = function SvgApartment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apartment",
    width: 550,
    height: 550,
    viewBox: "0 0 120.35 120.35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ebebeb;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #f0f0f0;\n      }\n\n      .cls-2, .cls-3, .cls-6 {\n        stroke: #090607;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6 {\n        stroke-width: 1px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #236a92;\n      }\n\n      .cls-4 {\n        fill: #090607;\n        stroke: #f59100;\n        stroke-width: 10px;\n      }\n\n      .cls-5 {\n        stroke: #236a92;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1_copy",
    "data-name": "Ellipse 1 copy",
    className: "cls-1",
    cx: 60.175,
    cy: 60.175,
    r: 54.705
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1478.39,296.8h48.21v51.231h-48.21V296.8Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_5",
    "data-name": "Rectangle 2 copy 5",
    className: "cls-3",
    d: "M1497.2,279h36.86v44.224H1497.2V279Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_copy",
    "data-name": "Shape 5 copy",
    className: "cls-4",
    d: "M1493.41,297.125v50.9",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy_3",
    "data-name": "Shape 3 copy 3",
    className: "cls-5",
    d: "M1491.99,303.075v1.634h-9.5v-1.634h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy_4",
    "data-name": "Shape 3 copy 4",
    className: "cls-5",
    d: "M1491.99,314.513v1.634h-9.5v-1.634h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy_5",
    "data-name": "Shape 3 copy 5",
    className: "cls-5",
    d: "M1491.99,325.952v1.634h-9.5v-1.634h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy_6",
    "data-name": "Shape 3 copy 6",
    className: "cls-5",
    d: "M1491.99,337.8v1.635h-9.5V337.8h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy",
    "data-name": "Rectangle 2 copy",
    className: "cls-6",
    d: "M1490.65,285.9h48.21v62.138h-48.21V285.9Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M1505.07,300.454h7.69v10.764h-7.69V300.454Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_3",
    "data-name": "Rectangle 2 copy 3",
    className: "cls-2",
    d: "M1514.46,290.223h4.88V295.4h-4.88v-5.179Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1479.12,345.587v-1.634h59.41v1.634h-59.41Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1505.29,303.845h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy",
    "data-name": "Shape 1 copy",
    className: "cls-2",
    d: "M1505.29,307.113h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2",
    "data-name": "Shape 1 copy 2",
    className: "cls-2",
    d: "M1509.03,300.435v10.408",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2-2",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M1521.01,300.454h7.67v10.764h-7.67V300.454Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1521.22,303.845h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-2",
    "data-name": "Shape 1 copy",
    className: "cls-2",
    d: "M1521.22,307.113h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2-2",
    "data-name": "Shape 1 copy 2",
    className: "cls-2",
    d: "M1524.96,300.435v10.408",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2-3",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M1505.07,315.153h7.69v10.79h-7.69v-10.79Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1505.29,318.552h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-3",
    "data-name": "Shape 1 copy",
    className: "cls-2",
    d: "M1505.29,321.82h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2-3",
    "data-name": "Shape 1 copy 2",
    className: "cls-2",
    d: "M1509.03,315.142V325.55",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2-4",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M1505.07,330.665h7.69v10.789h-7.69V330.665Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_4",
    "data-name": "Rectangle 2 copy 4",
    className: "cls-2",
    d: "M1519.8,333.736h10.12V348H1519.8V333.736Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_copy_2",
    "data-name": "Shape 5 copy 2",
    className: "cls-4",
    d: "M1526.74,333.892v13.97",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1503.02,305.526v1.634h-9.5v-1.634h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy",
    "data-name": "Shape 3 copy",
    className: "cls-2",
    d: "M1503.02,318.6v1.634h-9.5V318.6h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_copy_2",
    "data-name": "Shape 3 copy 2",
    className: "cls-2",
    d: "M1503.02,332.488v1.634h-9.5v-1.634h9.5Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1505.29,334.075h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-4",
    "data-name": "Shape 1 copy",
    className: "cls-2",
    d: "M1505.29,337.343h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2-4",
    "data-name": "Shape 1 copy 2",
    className: "cls-2",
    d: "M1509.03,330.665v10.408",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_copy_2-5",
    "data-name": "Rectangle 2 copy 2",
    className: "cls-2",
    d: "M1521.01,315.153h7.67v10.79h-7.67v-10.79Z",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1521.22,318.552h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy-5",
    "data-name": "Shape 1 copy",
    className: "cls-2",
    d: "M1521.22,321.82h7.47",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_copy_2-5",
    "data-name": "Shape 1 copy 2",
    className: "cls-2",
    d: "M1524.96,315.142V325.55",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1504.34,279.146v6.595",
    transform: "translate(-1448.78 -260.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1497.27,286.079v10.767",
    transform: "translate(-1448.78 -260.778)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApartment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apartment.e400f84f.svg";
export { ForwardRef as ReactComponent };